import { heroBg, styles } from "@/mocks/blcomics";

interface HeroProps {
  query: string;
  onQueryChange: (v: string) => void;
}

export default function Hero({ query, onQueryChange }: HeroProps) {
  const goLibrary = () =>
    document.getElementById("library")?.scrollIntoView({ behavior: "smooth" });

  const stats = [
    { num: "8", label: "精选画风" },
    { num: "15+", label: "高分作品" },
    { num: "8.8", label: "作品均分" },
  ];

  return (
    <section id="top" className="relative flex min-h-[560px] md:min-h-[660px] w-full items-center justify-center overflow-hidden">
      <img
        src={heroBg}
        alt="BL漫画精美画风的浪漫插画背景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-background-50"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-24 text-center md:px-6 md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-xs font-medium tracking-wide text-white backdrop-blur">
          <i className="ri-sparkling-2-line" aria-hidden="true"></i>
          收录 BL漫画画风好看、精美细腻的精选作品
        </span>
        <h1 className="mt-6 font-heading text-3xl leading-tight text-white md:text-5xl">
          按画风筛选，遇见心仪的 BL 漫画
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
          从水彩晕染到水墨国风，从厚涂光影到清新淡彩——漫屿为你整理 BL 漫画画风推荐与筛选列表，
          用直观的画风标签快速找到作画精美细腻的作品。
        </p>

        <form
          className="mx-auto mt-8 flex w-full max-w-xl flex-col gap-2 sm:flex-row"
          onSubmit={(e) => {
            e.preventDefault();
            goLibrary();
          }}
        >
          <div className="relative flex-1">
            <i
              className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-foreground-400"
              aria-hidden="true"
            ></i>
            <input
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              type="text"
              placeholder="搜索作品、作者或题材，如“水墨”"
              className="h-12 w-full rounded-full border border-transparent bg-white pl-11 pr-4 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
          </div>
          <button
            type="submit"
            className="h-12 whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            开始筛选
          </button>
        </form>

        <div className="mt-9 flex items-center justify-center gap-4 sm:gap-6">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading text-2xl text-white md:text-3xl">{s.num}</p>
              <p className="mt-1 text-xs text-white/75">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {styles.slice(0, 5).map((s) => (
            <a
              key={s.name}
              href="#library"
              className="whitespace-nowrap rounded-full border border-white/30 bg-white/10 px-3.5 py-1.5 text-xs text-white/90 backdrop-blur transition hover:bg-white/25"
            >
              {s.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}